import { useTheme } from "@mui/material/styles";
import Divider from "@mui/material/Divider";

import { useCardDefault } from "features/pay/fabric";
import PaymentMethods from "features/pay/ui/PaymentMethods";

import Back from "ui/base/Back";
import Page from "ui/Page";


export default function AccountMethods() {
	const theme = useTheme();
	const update = useCardDefault();

	const style = {
		body: {
			mt: theme.spacing(2.5),
			gap: theme.spacing(3),
			maxWidth: "sm"
		},
		methods: {
			boxShadow: "0px 4px 35px 0px rgba(0, 0, 0, 0.25)"
		}
	};

	return (
		<Page maxWidth="md">
			<Back to="/account" label="Account" />
			<Page.Header title="Payment methods" subtitle="Customize your payment methods" />
			<Divider flexItem />
			<Page.Body sx={style.body}>
				<PaymentMethods
					defaultExpanded
					action
					click={update.mutate}
					sx={style.methods}
				/>
			</Page.Body>
		</Page>
	);
}